<template>
    <div id="app">
        <div class="container">
            <img src="../public/header.jpg" class="img-fluid cover">
        </div>
        <shoping-list />
    </div>
</template>

<script>
    import ShopingList from "./components/ShopingList"

    export default {
        components: {
            ShopingList
        }
    }
</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 15px;
    }
    .cover {
        border-radius:4px;
    }
        @media (min-width: 576px) {
        .modal-dialog {
            max-width: 900px!important; 
        }
    }
</style>
